// src/pages/Auth/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Tabs, Form, Input, Button, Typography, message, Card, Divider } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import './index.css';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const Auth = ({ loggedInUser, onLogout, onLogin }) => {
  const [activeTab, setActiveTab] = useState('login');
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  // 根据URL状态切换选项卡
  useEffect(() => {
    if (location.state?.tab === 'register') {
      setActiveTab('register');
    }
  }, [location.state]);

  const handleLogin = (values) => {
    setLoading(true);
    // 模拟登录请求
    setTimeout(() => {
      console.log('登录信息:', values);
      setLoading(false);
      message.success('登录成功！');
      // 模拟登录用户信息
      if (onLogin) {
        onLogin({
          id: 1,
          username: values.username,
          email: `${values.username}@example.com`
        });
      }
    }, 1500);
  };

  const handleRegister = (values) => {
    setLoading(true);
    // 模拟注册请求
    setTimeout(() => {
      console.log('注册信息:', values);
      setLoading(false);
      message.success('注册成功！请登录您的账户。');
      setActiveTab('login');
    }, 1500);
  };

  const loginFailed = (errorInfo) => {
    console.log('登录失败:', errorInfo);
    message.error('登录失败，请检查用户名和密码');
  };

  const registerFailed = (errorInfo) => {
    console.log('注册失败:', errorInfo);
    message.error('注册失败，请检查表单信息');
  };

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      <div className="blog-content auth-content">
        <div className="auth-container">
          <Card className="auth-card">
            <div className="auth-header">
              <Title level={2} className="auth-title">
                欢迎访问我的博客
              </Title>
              <Text type="secondary">
                {activeTab === 'login' ? '登录您的账户' : '创建新账户'}
              </Text>
            </div>

            <Tabs 
              activeKey={activeTab} 
              onChange={setActiveTab}
              centered
              className="auth-tabs"
            >
              <TabPane tab="登录" key="login">
                <Form
                  layout="vertical"
                  onFinish={handleLogin}
                  onFinishFailed={loginFailed}
                  requiredMark={false}
                >
                  <Form.Item
                    label="用户名"
                    name="username"
                    rules={[{ required: true, message: '请输入用户名!' }]}
                  >
                    <Input 
                      prefix={<UserOutlined />} 
                      placeholder="请输入用户名" 
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[{ required: true, message: '请输入密码!' }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="请输入密码"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item>
                    <div className="auth-forgot-password">
                      <a href="#">忘记密码？</a>
                    </div>
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      loading={loading}
                      block
                      size="large"
                    >
                      登录
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>

              <TabPane tab="注册" key="register">
                <Form
                  layout="vertical"
                  onFinish={handleRegister}
                  onFinishFailed={registerFailed}
                  requiredMark={false}
                >
                  <Form.Item
                    label="用户名"
                    name="username"
                    rules={[
                      { required: true, message: '请输入用户名!' },
                      { min: 3, message: '用户名至少3个字符' }
                    ]}
                  >
                    <Input 
                      prefix={<UserOutlined />} 
                      placeholder="请输入用户名" 
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    label="邮箱"
                    name="email"
                    rules={[
                      { required: true, message: '请输入邮箱地址!' },
                      { type: 'email', message: '请输入有效的邮箱地址!' }
                    ]}
                  >
                    <Input
                      prefix={<MailOutlined />}
                      placeholder="请输入邮箱地址"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    label="密码"
                    name="password"
                    rules={[
                      { required: true, message: '请输入密码!' },
                      { min: 6, message: '密码至少6个字符' }
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="请输入密码"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    label="确认密码"
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: '请确认密码!' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('两次输入的密码不一致!'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="请再次输入密码"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit" 
                      loading={loading}
                      block
                      size="large"
                    >
                      注册
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
            </Tabs>

            <Divider>或</Divider>
            
            <div className="auth-social-login">
              <Button block size="large" style={{ marginBottom: '12px' }}>
                <span>使用 GitHub 登录</span>
              </Button>
              <Button block size="large">
                <span>使用 Google 登录</span>
              </Button>
            </div>
          </Card>
        </div>
      </div>
      <AppFooter />
    </Layout>
  );
};

export default Auth;